import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { useAuth } from "context/AuthContext";

const CompanyScopeSelector = () => {
  const {
    profile,
    availableCompanies,
    selectedCompanyId,
    setSelectedCompanyId,
  } = useAuth();

  if (!profile?.is_superuser) {
    return null;
  }

  const handleChange = (event) => {
    setSelectedCompanyId(event.target.value);
  };

  const options = [
    { value: "ALL", label: "Todos os clientes" },
    ...(availableCompanies || []).map((company) => ({
      value: company.id,
      label: company.name || company.id,
    })),
  ];

  const currentValue = selectedCompanyId || "ALL";

  return (
    <VuiBox display="flex" flexDirection="column" alignItems="flex-start" mr={2}>
      <VuiTypography
        variant="button"
        color="white"
        fontWeight="medium"
        mb={1}
      >
        Visualizar dados de
      </VuiTypography>
      <FormControl
        size="small"
        fullWidth
        sx={{
          minWidth: 220,
          "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.7)" },
          "& .MuiInputLabel-root.Mui-focused": { color: "white" },
          "& .MuiSelect-select": { color: "white" },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.3)" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.6)" },
          "& .MuiSvgIcon-root": { color: "white" },
        }}
      >
        <InputLabel id="company-scope-selector-label">Empresa</InputLabel>
        <Select
          labelId="company-scope-selector-label"
          value={currentValue}
          label="Empresa"
          onChange={handleChange}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </VuiBox>
  );
};

export default CompanyScopeSelector;
